export default __webpack_public_path__ + "static/media/johnosb.63c0e40e.png";